<template>
  <div>
    <v-app-bar app
    color="primary"
    collapse-on-scroll>
      <v-btn icon dark @click='$router.go(-1)' v-show='showBackButton'><v-icon>mdi-reply</v-icon></v-btn>
      <v-app-bar-nav-icon class="white--text" @click.stop="toggleDrawer" v-if="showMainMenu" title='Menú'></v-app-bar-nav-icon>
      <v-toolbar-title class="white--text">SIDRA</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text" style='font-weight:500'>{{ adminInfo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text" style='font-weight:500'>{{ condoInfo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="white--text" style='font-weight:600; margin-right: 20px;'>{{ username }}</span>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            dark            
            v-on="on"
            title='Opciones del usuario'
            v-show='showUserMenu'
          >
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(uoption, index) in userOptions"
            :key="index"
            @click="goTo(uoption, index)"
          >
            <v-list-item-icon>
              <v-icon>{{ uoption.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ uoption.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  data() {
    const loginNames = ['home', 'login', 'logout'];
    const deadEnds = ['about', 'grid', 'user'];
    const temp = loginNames.concat(deadEnds);
    const userNotRequiredNames = temp.concat([]);
    userNotRequiredNames.pop();
    const adminNotRequiredNames = temp.concat(['administraciones']);
    const condoNotRequiredNames = adminNotRequiredNames.concat(['condominiosSelector']);
    return {
      userOptions: [
        { title: 'Datos de Usuario', icon: 'mdi-account-question' },
        { title: 'Cerrar Sesión', icon: 'mdi-logout' },
      ],
      menu: null,
      disableMainMenuNames: condoNotRequiredNames,
      enableBackButtonNames: deadEnds,
      disableUserMenuNames: userNotRequiredNames,
      adminNotRequiredNames,
      condoNotRequiredNames,
      userNotRequiredNames,
    };
  },
  created() {
    this.configureMenu();
    this.checkSessionData();
  },
  methods: {
    ...mapActions(['logout']),
    toggleDrawer() {
      this.$store.dispatch('toggleDrawer');
    },
    goTo(option, index) {
      console.log('Opción del menú: %o', option.title);
      switch (index) {
        case 0: this.$router.push({name: 'user'}); break;
        case 1: this.logout(); break;
      }
    },
    configureMenu() {
      const currentName = this.$route.name;
      // console.log('disableMainMenuNames: ', this.disableMainMenuNames);
      // console.log('enableBackButtonNames: ', this.enableBackButtonNames);
      // console.log('disableUserMenuNames: ', this.disableUserMenuNames);
      // console.log('adminNotRequiredNames: ', this.adminNotRequiredNames);
      // console.log('condoNotRequiredNames: ', this.condoNotRequiredNames);
      // console.log('userNotRequiredNames: ', this.userNotRequiredNames);
      if (this.disableMainMenuNames.includes(currentName)) {
        this.$store.dispatch('disableMainMenu');
      } else {
        this.$store.dispatch('enableMainMenu');
      }
      if (this.enableBackButtonNames.includes(currentName)) {
        this.$store.dispatch('enableBackButton');
      } else {
        this.$store.dispatch('disableBackButton');
      }
      if (this.disableUserMenuNames.includes(currentName)) {
        this.$store.dispatch('disableUserMenu');
      } else {
        this.$store.dispatch('enableUserMenu');
      }
    },
    checkSessionData() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const user = this.$store.getters.getUser;
      const currentName = this.$route.name;
      if (user === null && !this.userNotRequiredNames.includes(currentName)) {
        this.logout();
        return;
      }
      if (admin === null && !this.adminNotRequiredNames.includes(currentName)) {
        this.$router.push({name: 'administraciones'});
        return;
      }
      if (condo === null && !this.condoNotRequiredNames.includes(currentName)) {
        this.$router.push({name: 'condominiosSelector'});
      }
    },
  },
  computed: {
    ...mapGetters({
      showMainMenu: 'getShowMainMenu',
      showBackButton: 'getShowBackButton',
      showUserMenu: 'getShowUserMenu',
      username: 'getUsername',
    }),
    adminInfo() {
      const admin = this.$store.getters.getAdmin;
      if (admin === null) {
        return '';
      }
      return admin.shortName || admin.longName || '';
    },
    condoInfo() {
      const condo = this.$store.getters.getCondo;
      if (condo === null) {
        return '';
      }
      if (typeof(condo.nombre) === 'string' && condo.nombre.length > 0) {
        return condo.nombre;
      }
      return '';
    },
  },
  watch: {
    $route(to, from) {
      this.configureMenu();
      this.checkSessionData();
    },
  },
};
</script>

<style scoped lang="scss">
  @import "src/styles/style.scss";
</style>
